import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../containers/App';

import * as COM from '.';

export const Storage = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const auth = useContext(AuthContext);

    const set = async (data) => {
        try {
            await COM.setStorage(props.storageKey, data, auth);
        } catch(err) {
            console.log(err);
        }
    }

    const load = async () => {
        try {
            setLoading(true);
            let data = await COM.getStorage(props.storageKey, auth);
            setData(data);
            setLoading(false);
            props.onSuccess && props.onSuccess(data);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if (props.loadOnInit) {
            load();
        }
    }, props.invalidateEffect ? props.invalidateEffect : [])

    if (props.children) {
        return props.children(loading, data, load, set);
    } else {
        return null;
    }
};